export default function AdminDashboard(){return <div className='p-8'>Admin Dashboard</div>}